import React from "react";
import classnames from "classnames";
import "./Modal.scss";

const Modal = ({ children, onClose, className }) => {
  return (
    <div className={classnames("modal", className)}>
      <div className="modal__overlay" onClick={onClose} />
      <div className="modal__content">{children}</div>
    </div>
  );
};

export default Modal;
